export const idtype = `
  id
  typeHandle
`;

export const generalLink = `
  type
  value
  label
  defaultLabel
  urlSuffix
  url
  link
  target
  title
  class
  rel
  ariaLabel
  download
  filename
  elementType
  elementId
  elementSiteId
  elementTitle
  element {
    id
    uri
    title
  }
`;

export const link = `
  url
  text
  type
  element {
    id
    uri
    title
  }
`;

export const fieldLinkTo = `
fieldLinkTo {
  ${generalLink}
}
`;

export const linkTo = `
    linkTo: ${fieldLinkTo}
`;

const secondaryLinkTo = `
secondaryLinkTo {
  ${generalLink}
}
`;

export const secondaryLink = `
    secondaryLink: ${secondaryLinkTo}

`;

const buttonLinkTo = `
buttonLinkTo {
  ${generalLink}
}
`;

export const buttonLink = `
    buttonLink: ${buttonLinkTo}
`;

export const imageAsset = `
  ... on images_Asset {
    optimized: optimizedImage {
      placeholder: placeholderImage
      srcset
      srcsetWebp
      focalPoint
    }
    altText
    title
    url
    id
  }
`;

export const image = `
  image {
    ${imageAsset}
  }
`;

export const image32 = `
  image32 {
    ...on images_Asset {
      optimized: optimized32 {
        placeholder: placeholderImage
        srcset
        srcsetWebp
      }
      altText
      title
      url
    }
  }
`;
export const image54 = `
  image54 {
    ...on images_Asset {
      optimized: optimized54 {
        placeholder: placeholderImage
        srcset
        srcsetWebp
      }
      altText
      title
      url
    }
  }
`;

export const image169 = `
  image169 {
    ...on images_Asset {
      optimized: optimized169 {
        placeholder: placeholderImage
        srcset
        srcsetWebp
      }
      altText
      title
      url
    }
  }
`;

export const squareImage = `
  image {
    ... on images_Asset {
      optimized: square {
        placeholder: placeholderImage
        srcset
        srcsetWebp
      }
      altText
      title
      url
    }
  }
`;

export const images = `
  images {
    ${imageAsset}
  }
`;

export const svgIcon = `
svgIcon {
  url
  ...on images_Asset {
    optimized: optimizedImage {
      placeholder: placeholderBox(color: "transparent")
    }
  }
}
`;

export const programAttributeList = `
  programAttributeList {
    ...on programAttribute_Entry {
      ${idtype}
      heading
      more
    }
  }
`;

export const headingTextItems = `
  headingTextItems {
    ...on headingTextItemsItem_Entry {
      ${idtype}
      heading
      text
    }
  }
`;

export const teamMember = `
  ...on team_Entry {
    id
    fullName: title
    firstName
    lastName
    ${image}
    attribution
    teamType {
      id
      title
    }
  }
`;
